var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 138.51 109.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1985.11,95.94h-60.49c-1.5,0-3.34.49-4.42-.2-1.73-1.1-4.06-3-4.1-4.56s2.25-3.49,3.91-4.73c.87-.66,2.58-.23,3.91-.23h122.47c1.17,0,2.65-.42,3.44.13,1.83,1.29,4.56,3,4.6,4.64s-2.59,3.51-4.41,4.78c-.9.64-2.59.17-3.92.17Z",
    transform: "translate(2054.19 -86.05)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1985.31,145.94h-60.49c-1.33,0-3,.48-3.92-.16-1.8-1.28-4.4-3.2-4.36-4.79s2.76-3.3,4.54-4.66c.64-.48,1.94-.11,2.94-.11q61.49,0,123,0c1.16,0,2.68-.42,3.43.15,1.77,1.35,4.45,3.21,4.4,4.8s-2.74,3.41-4.61,4.63c-.94.61-2.59.14-3.92.14Z",
    transform: "translate(2054.19 -86.05)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-1984.73,186.2q30.49,0,61,0c1.65,0,3.63-.31,4.87.46,1.48.92,3.18,2.86,3.19,4.37s-1.68,3.46-3.15,4.39c-1.23.78-3.22.48-4.87.48q-61.24,0-122.48,0c-1.65,0-3.63.3-4.87-.48-1.46-.91-3.13-2.85-3.14-4.35s1.65-3.45,3.1-4.37c1.23-.79,3.22-.5,4.87-.5Q-2015.47,186.19-1984.73,186.2Z",
    transform: "translate(2054.19 -86.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerIcon);
export default __webpack_public_path__ + "static/media/hamburger_icon.214ab4bc41896641f36aa22393c74457.svg";
export { ForwardRef as ReactComponent };